import { dayLabel } from '@/lib/transactions/dates';

const MS_PER_MINUTE = 60_000;
const MS_PER_HOUR = 3_600_000;

/**
 * pt-BR relative-time phrase for a recent timestamp — "agora", "há 5 min",
 * "há 2 h" — falling back to the calendar day label ("Ontem", "qua, 6 mai")
 * once the moment is more than a day old. Future timestamps read "agora":
 * they only occur through clock skew, and "em 2 min" would be a lie.
 * Returns null for anything unparseable so callers can render nothing.
 */
export function relativeTimeLabel(iso: string, now: Date = new Date()): string | null {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;

  const elapsedMs = now.getTime() - date.getTime();
  if (elapsedMs < MS_PER_MINUTE) return 'agora';
  if (elapsedMs < MS_PER_HOUR) return `há ${Math.floor(elapsedMs / MS_PER_MINUTE)} min`;
  if (elapsedMs < 24 * MS_PER_HOUR) return `há ${Math.floor(elapsedMs / MS_PER_HOUR)} h`;
  return dayLabel(date, now);
}
